export default __webpack_public_path__ + "static/media/1.575dfb06.png";